import React from 'react';
import { Zap, Gift, Mail, LogIn, UserPlus, X, Sparkles, Clock, TrendingUp, DownloadCloud, Save, Share2 } from 'lucide-react';

// Placeholders for your external files/constants.
const TPT_PURCHASE_LINK = "https://www.teacherspayteachers.com/Product/TPT-Seller-SEO-Listing-Optimizer-App-Create-Titles-Description-Product-Links-13645689?utm_source=Mr%20Joel%20Site%20&utm_campaign=Mr%20Joel%20Site";

const Disclaimer = ({ className }) => (
    <div className={`text-slate-400 ${className}`}>
        <p>
            Disclaimer: This tool is independently developed and is not officially endorsed, authorized, or affiliated with Teachers Pay Teachers (TPT). The app is designed to support TPT sellers in improving their listings.
        </p>
    </div>
);


const AuthModal = ({
    onClose,
    authMode, setAuthMode,
    email, setEmail,
    password, setPassword,
    authError, setAuthError,
    showForgotPassword, setShowForgotPassword,
    resetEmail, setResetEmail,
    resetMessage, setResetMessage,
    tptStoreUrlInput, setTptStoreUrlInput,
    handleAuthAction, handlePasswordReset,
    authModalMessage,
    handleGoogleSignIn
}) => {
    return (
        <div className="fixed inset-0 bg-slate-800 bg-opacity-75 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col">
                <div className="flex justify-between items-center p-4 border-b border-slate-200">
                    <h2 className="text-xl font-semibold text-sky-700">
                        {authMode === 'login' ? 'Welcome Back!' : 'Create Your Account'}
                    </h2>
                    <button
                        onClick={onClose}
                        className="p-1 text-slate-400 hover:text-slate-600 rounded-full hover:bg-slate-100"
                        aria-label="Close"
                    >
                        <X size={24} />
                    </button>
                </div>

                <div className="p-6 sm:p-8 overflow-y-auto">

                    {/* --- CHANGE: Combined sections into a single unified box --- */}
                    <div className="border border-slate-200 rounded-lg shadow-sm mb-6 text-center text-sm overflow-hidden p-4 bg-slate-50">
                        {/* Free Trial Section */}
                        <div className="text-slate-800">
                            <div className="flex items-center justify-center mb-1">
                                <Gift size={20} className="mr-2 text-green-600 flex-shrink-0" />
                                <p className="font-semibold">New User?</p>
                            </div>
                            <p className="font-bold">Start Your FREE 1-Hour Trial!</p>
                            <p className="text-xs text-slate-600">(No payment method needed, just sign up below!)</p>
                        </div>

                        <div className="w-full h-px bg-slate-200 my-3"></div>

                        {/* Purchase Section */}
                        <div className="text-slate-800">
                             <p className="font-bold">
                                Full lifetime access for just $79.99!
                            </p>
                            <p className="text-xs mt-1 text-slate-600">
                                Purchase directly through the TPT product page: <br />
                                <a href={TPT_PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:text-sky-800 underline font-medium">
                                    TPT Listing Optimizer Pro App
                                </a>
                            </p>
                        </div>
                    </div>

                    {/* "Experience the Power" section */}
                    <div className="mt-4 mb-6 pt-4 border-t border-slate-200">
                        <h3 className="text-md font-semibold text-sky-700 mb-3 text-center">Experience the Power!</h3>
                        <ul className="space-y-2.5 text-sm">
                             <li className="flex items-start">
                                <Sparkles className="h-4 w-4 mr-2.5 mt-0.5 flex-shrink-0 text-amber-500" />
                                <span className="text-slate-600"><b>Instant Content Creation:</b> Generate new descriptions and titles that sell instantly.</span>
                            </li>
                             <li className="flex items-start">
                                <Clock className="h-4 w-4 mr-2.5 mt-0.5 flex-shrink-0 text-blue-500" />
                                <span className="text-slate-600"><b>Save Hours Weekly:</b> More creating, less writing.</span>
                            </li>
                             <li className="flex items-start">
                                <TrendingUp className="h-4 w-4 mr-2.5 mt-0.5 flex-shrink-0 text-green-500" />
                                <span className="text-slate-600"><b>Boost Your Visibility:</b> SEO optimized for TPT and keyword rank tracking.</span>
                            </li>
                             <li className="flex items-start">
                                <DownloadCloud className="h-4 w-4 mr-2.5 mt-0.5 flex-shrink-0 text-indigo-500" />
                                <span className="text-slate-600"><b>Import & Revamp:</b> Instantly upgrade listings by importing descriptions direct from TPT URLs.</span>
                            </li>
                             <li className="flex items-start">
                                <Share2 className="h-4 w-4 mr-2.5 mt-0.5 flex-shrink-0 text-pink-500" />
                                <span className="text-slate-600"><b>Social Media Wizard:</b> Craft engaging captions for Instagram, Facebook, and more.</span>
                            </li>
                             <li className="flex items-start">
                                <Save className="h-4 w-4 mr-2.5 mt-0.5 flex-shrink-0 text-slate-500" />
                                <span className="text-slate-600"><b>All Your Work Saved:</b> Access & edit anytime.</span>
                            </li>
                        </ul>
                    </div>

                    {!showForgotPassword ? (
                        <>
                           {/* Google Sign-In Button */}
                            <button
                                type="button"
                                onClick={handleGoogleSignIn}
                                className="w-full flex items-center justify-center py-2.5 px-4 mb-4 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-50 transition-colors shadow-sm"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20px" height="20px" className="mr-3">
                                    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
                                    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
                                    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
                                    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.574l6.19,5.238C42.022,36.219,44,30.64,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
                                </svg>
                                <span className="font-semibold text-sm">Sign {authMode === 'login' ? 'in' : 'up'} with Google</span>
                            </button>

                            <div className="relative mb-4">
                                <div className="absolute inset-0 flex items-center">
                                    <div className="w-full border-t border-slate-300" />
                                </div>
                                <div className="relative flex justify-center text-sm">
                                    <span className="bg-white px-2 text-slate-500">Or continue with email</span>
                                </div>
                            </div>

                            <div className="flex border border-slate-300 rounded-lg p-1 mb-4">
                                <button
                                    onClick={() => { setAuthMode('signup'); setAuthError(''); }}
                                    className={`w-1/2 py-2 text-sm font-semibold rounded-md transition-colors ${authMode === 'signup' ? 'bg-sky-600 text-white shadow' : 'text-slate-600 hover:bg-slate-100'}`}
                                >
                                    Sign Up
                                </button>
                                <button
                                    onClick={() => { setAuthMode('login'); setAuthError(''); }}
                                    className={`w-1/2 py-2 text-sm font-semibold rounded-md transition-colors ${authMode === 'login' ? 'bg-sky-600 text-white shadow' : 'text-slate-600 hover:bg-slate-100'}`}
                                >
                                    Login
                                </button>
                            </div>

                            <form onSubmit={(e) => { e.preventDefault(); handleAuthAction(authMode); }} className="space-y-3">
                                <div>
                                    <label htmlFor="modal-email" className="block text-xs font-medium text-slate-700">Email Address</label>
                                    <input
                                        type="email" id="modal-email" value={email} onChange={(e) => setEmail(e.target.value)}
                                        className="mt-1 w-full p-2.5 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-sky-500 focus:border-sky-500 text-sm"
                                        placeholder="you@example.com" required autoComplete="email"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="modal-password" className="block text-xs font-medium text-slate-700">Password</label>
                                    <input
                                        type="password" id="modal-password" value={password} onChange={(e) => setPassword(e.target.value)}
                                        className="mt-1 w-full p-2.5 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-sky-500 focus:border-sky-500 text-sm"
                                        placeholder="••••••••" required autoComplete={authMode === 'login' ? "current-password" : "new-password"}
                                    />
                                </div>
                                {authMode === 'signup' && (
                                    <div>
                                        <label htmlFor="modal-tptStoreUrl" className="block text-xs font-medium text-slate-700">
                                            TPT Store Link <span className="text-xs text-slate-500">(Optional - helps verify purchase)</span>
                                        </label>
                                        <input
                                            type="url" id="modal-tptStoreUrl" value={tptStoreUrlInput} onChange={(e) => setTptStoreUrlInput(e.target.value)}
                                            className="mt-1 w-full p-2.5 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-sky-500 focus:border-sky-500 text-sm"
                                            placeholder="https://www.teacherspayteachers.com/Store/Your-Store-Name"
                                        />
                                    </div>
                                )}
                                {authError && <p className="text-xs text-red-600 text-center">{authError}</p>}
                                {resetMessage && !authError && <p className="text-xs text-green-600 text-center">{resetMessage}</p>}
                                <button
                                    type="submit"
                                    className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold py-2.5 px-4 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 transition-colors flex items-center justify-center text-sm"
                                >
                                    {authMode === 'login' ? <LogIn className="mr-2 h-4 w-4" /> : <UserPlus className="mr-2 h-4 w-4" />}
                                    {authMode === 'login' ? 'Login' : 'Sign Up & Start Free Trial'}
                                </button>
                            </form>
                            <div className="mt-3 text-center">
                                {authMode === 'login' && !showForgotPassword && (
                                    <button onClick={() => { setShowForgotPassword(true); setAuthError(''); setResetMessage(''); }}
                                        className="block w-full text-xs text-slate-500 hover:text-sky-700">
                                        Forgot Password?
                                    </button>
                                )}
                            </div>
                        </>
                    ) : (
                         <>
                            <div className="text-center mb-4">
                                <Mail className="h-10 w-10 text-sky-600 mx-auto mb-2" />
                                <h3 className="text-lg font-semibold text-slate-800">Reset Your Password</h3>
                                <p className="text-xs text-slate-600 mt-1">
                                    Enter your email address and we'll send you a link to reset your password.
                                </p>
                            </div>
                            <form onSubmit={handlePasswordReset} className="space-y-3">
                                <div>
                                    <label htmlFor="modal-resetEmail" className="block text-xs font-medium text-slate-700">Email Address</label>
                                    <input
                                        type="email" id="modal-resetEmail" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)}
                                        className="mt-1 w-full p-2.5 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-sky-500 focus:border-sky-500 text-sm"
                                        placeholder="you@example.com" required autoComplete="email"
                                    />
                                </div>
                                {authError && <p className="text-xs text-red-600 text-center">{authError}</p>}
                                {resetMessage && !authError && <p className="text-xs text-green-600 text-center">{resetMessage}</p>}
                                <button
                                    type="submit"
                                    className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold py-2.5 px-4 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 transition-colors flex items-center justify-center text-sm"
                                >
                                    <Mail className="mr-2 h-4 w-4" /> Send Reset Link
                                </button>
                            </form>
                            <button onClick={() => { setShowForgotPassword(false); setAuthError(''); setResetMessage(''); }}
                                className="mt-3 w-full text-xs text-sky-600 hover:text-sky-800">
                                Back to Login
                            </button>
                        </>
                    )}

                    <Disclaimer className="mt-6 text-xs" />
                </div>
            </div>
        </div>
    );
};

export default AuthModal;
